import {
  SET_ACTIVE_ACCOUNT,
  SET_ACTIVE_MESSAGES,
  CLEAR_ACTIVE_MESSAGES,
  SET_AUDIT_LOG,
  CLEAR_ACTIVE_AUDIT_LOG,
  SET_NOTES,
  CLEAR_NOTES,
  ADD_NOTE,
  CLEAR_ACTIVE_ACCOUNT_TYPE,
} from "../constants";
import { AccountSearchResult } from "../../types/search";
import { CommunicationsResult } from "../../types/communications";
import { AuditLog } from "../../types/audit";
import { Note } from "../../types/note";

const initial_state = {
  loading: false,
  account_info: {} as AccountSearchResult,
  messages: {
    totalResults: 0,
    list: [] as CommunicationsResult[],
  },
  audit_log: {
    totalResults: 0,
    list: [] as AuditLog[],
  },
  notes: {
    totalResults: 0,
    list: [] as Note[],
  },
};

interface stateOptions {
  type: string;
  payload?: any;
}

export default function Active(state = initial_state, { type, payload }: stateOptions) {
  switch (type) {
    case SET_ACTIVE_ACCOUNT:
      return {
        ...state,
        loading: false,
        account_info: payload,
      };

    case SET_ACTIVE_MESSAGES:
      return {
        ...state,
        loading: false,
        messages: {
          totalResults: payload.totalResults,
          list: payload.messages,
        },
      };

    case CLEAR_ACTIVE_MESSAGES:
      return {
        ...state,
        loading: false,
        messages: {
          totalResults: 0,
          list: [],
        },
      };

    case SET_AUDIT_LOG:
      return {
        ...state,
        loading: false,
        audit_log: {
          totalResults: payload.totalResults,
          list: payload.results,
        },
      };

    case CLEAR_ACTIVE_AUDIT_LOG:
      return {
        ...state,
        loading: false,
        audit_log: {
          totalResults: 0,
          list: [],
        },
      };

    case SET_NOTES:
      return {
        ...state,
        loading: false,
        notes: {
          totalResults: payload.totalResults,
          list: payload.notes,
        },
      };

    case CLEAR_NOTES:
      return {
        ...state,
        loading: false,
        notes: {
          totalResults: 0,
          list: [],
        },
      };
    case CLEAR_ACTIVE_ACCOUNT_TYPE:
      return {
        ...state,
        account_info: payload,
      };

    case ADD_NOTE:
      return {
        ...state,
        loading: false,
        notes: {
          totalResults: state.notes.totalResults + 1,
          list: state.notes.list.concat(payload),
        },
      };

    default:
      return state;
  }
}
